// 数字を含む文字列は自然順（2 < 10）、純文字列は辞書順で比較する共通コレーター。
const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

export function naturalSort(items: readonly string[]): string[] {
    return [...items].sort((a, b) => collator.compare(a, b));
}

// 表示ラベル等、任意キーで自然順／辞書順に並べる。
export function naturalSortBy<T>(items: readonly T[], key: (item: T) => string): T[] {
    return [...items].sort((a, b) => collator.compare(key(a), key(b)));
}
